import Utils from "./utils.class";
import { Character } from "./character.class";
import { DraggableItem, DraggableItemObj } from "./draggable-item.class";
import { Rectangle } from "./rectangle.class";
import { Scenario } from "./scenario.class";
import { TextBubble } from "./text-bubble.class";
import { Figure } from "./figure.class";

export class DraggableItemFactory {
  static fromObj(obj: DraggableItemObj, imgSrc: string): DraggableItem {
    const classes = {
      characters: Character,
      rectangles: Rectangle,
      scenarios: Scenario,
      textBubbles: TextBubble,
      figures: Figure,
    };

    const _obj: any = { ...obj };
    delete _obj.type;
    return new classes[obj.type](_obj, imgSrc);
  }

  static clone(item: DraggableItem, keepId = false): DraggableItem {
    const obj = item.toObj();
    if (!keepId) obj.id = Utils.generateRandomId();

    return DraggableItemFactory.fromObj(obj, item.image.src);
  }
}
